/**
 * Created by Pradeep Kumar on 01/18/2019.
 */

import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {CreepyCarnivalTwoParsedGameData} from "../server/data/CreepyCarnivalTwoParsedGameData";
import {CreepyCarnivalTwoGameMode} from "../gamemode/CreepyCarnivalTwoGameMode";

export class CreepyCarnivalTwoSpinController extends SpinController {

    private _stickySymbols: boolean[];

    protected getReelsGameConfigFromPreviousGameData(): boolean[] {
        let config: boolean[] = super.getReelsGameConfigFromPreviousGameData();

        if (this._mode === CreepyCarnivalTwoGameMode.RESPIN || this._mode === "RESPIN_FREESPIN") {
            config = this._stickySymbols;
        }
        return config;

    }

    protected parseGameData(data: CreepyCarnivalTwoParsedGameData): void {
        this._stickySymbols = data.respinPositions ? data.respinPositions.reduce((acc, currEl) => acc.concat(currEl), []) : [];
    }
}
